import { clientCookies } from "@/lib/clientCookies"

/**
 * Set once after a user's first successful TID login. Its presence lets
 * useAuthCheck skip the silent SSO (`prompt=none`) redirect for visitors
 * who have never logged in, since they can't have an active TID session.
 */
export const TID_KNOWN_USER_COOKIE = "tid_known_user"
const KNOWN_USER_COOKIE_EXPIRY_DAYS = 7

export const markUserAsKnown = (): void => {
  clientCookies.set(TID_KNOWN_USER_COOKIE, "1", {
    expires: KNOWN_USER_COOKIE_EXPIRY_DAYS,
    sameSite: "lax",
  })
}

export const isKnownUser = (): boolean =>
  clientCookies.get(TID_KNOWN_USER_COOKIE) === "1"

export const clearKnownUser = (): void => {
  clientCookies.remove(TID_KNOWN_USER_COOKIE)
}
